import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers"; // Import your combined reducers
import rootSaga from "./sagas"; // Import your root saga

// Create the saga middleware
console.log("Starting saga middleware");
// console.log(`PMM - SF - store.js - just before running createSagaMiddleware`);
const sagaMiddleware = createSagaMiddleware();
// console.log(`PMM - SF - store.js - just before running createSagaMiddleware`);
console.log("Saga middleware started");

// Create the Redux store with the saga middleware
// const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

// Run the root saga
// sagaMiddleware.run(rootSaga,middleware: (getDefaultMiddleware) =>
//   getDefaultMiddleware().concat(sagaMiddleware),);

sagaMiddleware.run(rootSaga);

export default store;
